import { AxiosResponseInterceptor } from '../types';
import { HttpHeader, HttpStatus } from '../../constants/http';
import axios, { AxiosResponse } from 'axios';
import { store } from '../../app/store';
import { selectRefreshToken, selectServiceURL, setAccessToken } from '../../app/slices/auth.slice';
import { client } from '../client';

export const refresh: AxiosResponseInterceptor = {
	onFulfilled: async (response) => {
		if (response.status === HttpStatus.RESET_CONTENT) {
			const token = getRefreshedToken(response);
			store.dispatch(setAccessToken(token));

			return await client.request(response.config);
		}

		return response;
	},

	onRejected: async (error) => {
		if (!isAuthorizationTokenExpired(error)) throw error;

		try {
			const longTermToken = getRefreshToken();
			const token = await fetchRefreshedShortTermToken(longTermToken);
			store.dispatch(setAccessToken(token));
			return await client.request(error.config);
		} catch (err) {
			throw err;
		}
	}
};

const isAuthorizationTokenExpired = (error: any): boolean => {
	const response = error.response;
	return response && response.status === HttpStatus.UNAUTHORIZED;
};

const getRefreshToken = (): string => {
	const state = store.getState();
	const token = selectRefreshToken(state);
	if (!token) throw new Error(`Refresh (long term) token not defined inside store, received: ${token}`);
	return token;
};

const fetchRefreshedShortTermToken = async (token: string) => {
	const baseURL = getApiURL();
	const URL = `${baseURL}check/token`;
	const response = await axios.request({
		method: 'GET',
		url: URL,
		headers: {
			[HttpHeader['Authorization']]: token,
			[HttpHeader['Check-Origin']]: 'popup'
		}
	});

	if (!isTokenRefreshedResponse(response)) {
		throw new Error(`Received unsupported response on token refresh: ${response.status}`);
	}

	return getRefreshedToken(response);
};

const getApiURL = () => {
	const state = store.getState();
	const URL = selectServiceURL(state);
	if (!URL) throw new Error('Api service URL not defined inside store');
	return URL;
};

const isTokenRefreshedResponse = (response: AxiosResponse): boolean => {
	return response.status === HttpStatus.RESET_CONTENT;
};

const getRefreshedToken = (response: AxiosResponse) => {
	const headers = response.headers;
	const token = headers[HttpHeader['x-check-token']];
	if (!token) throw new Error('Refresh short term token not defined on HTTP 205 Reset');
	return token;
};
